<template>
	<v-dialog
		v-model="visible_local" 
		persistent
		:retain-focus="false"
		:fullscreen="is_fullscreen"
	>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<NewSubTask
			v-if="parent_task_item"
			:taskDetail="parent_task_item"
			:startTime="start_time"
			:endTime="end_time"
			:color="'#81CC00'"
			:isSubTaskCreation="true"
			@close="onClose()"
		/>
	</v-dialog>
</template>

<script>
import NewSubTask from "@/views/tasks/new_task.vue";

export default {
	name: 'EditTimesheetDialog',
	data() {
		return {
			visible_local: true,
			is_fullscreen: true,

			loading: false,
			error_msg: '',

			task_id: 0,
			start_time: '',
			end_time: '',
			parent_task_item: null
		}
	},
	components: {
		NewSubTask
	},
	created() {
		this.task_id = Number(this.$route.params.evid);
		this.start_time = this.$route.query.start_time && this.$route.query.start_time.length !== 0 ? this.$route.query.start_time : '';
		this.end_time = this.$route.query.end_time && this.$route.query.end_time.length !== 0 ? this.$route.query.end_time : '';

		this.getTask(this.task_id);
	},
	methods: {
		async getTask(id) {
			this.loading = true;

			const url = `/api/tasks/${id}?comments=true&worked_on=true`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.loading = false;
						this.parent_task_item = data;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onClose() {
			window.open("/close")
		}
	}
}
</script>


